import { h, s } from '../lib/dom';

/** A large decorative orbit ring. Visual only. */
export function renderOrbit(): HTMLElement {
  const svg = s('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 600 600',
    'aria-hidden': 'true',
  });

  const defs = s('defs');
  defs.innerHTML = `
    <radialGradient id="ogr" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="rgba(255,153,51,0.18)"/>
      <stop offset="60%" stop-color="rgba(6,3,141,0.05)"/>
      <stop offset="100%" stop-color="transparent"/>
    </radialGradient>
  `;
  svg.append(defs);

  svg.append(s('circle', { cx: 300, cy: 300, r: 280, fill: 'url(#ogr)' }));

  const ring = s('g', { class: 'ring' });
  for (let i = 0; i < 36; i++) {
    const r = 230;
    const a = (i / 36) * Math.PI * 2;
    ring.append(s('circle', {
      cx: 300 + Math.cos(a) * r,
      cy: 300 + Math.sin(a) * r,
      r: i % 6 === 0 ? 3 : 1.2,
      fill: i % 6 === 0 ? '#FF9933' : 'rgba(255,255,255,0.55)',
    }));
  }
  svg.append(s('circle', { cx: 300, cy: 300, r: 230, fill: 'none', stroke: 'rgba(255,255,255,0.12)', 'stroke-width': 1 }));
  svg.append(ring);

  const innerRing = s('g', { class: 'ring-rev' });
  innerRing.append(s('circle', { cx: 300, cy: 300, r: 160, fill: 'none', stroke: 'rgba(255,255,255,0.16)', 'stroke-width': 1, 'stroke-dasharray': '2 6' }));
  for (let i = 0; i < 6; i++) {
    const a = (i / 6) * Math.PI * 2;
    innerRing.append(s('circle', {
      cx: 300 + Math.cos(a) * 160,
      cy: 300 + Math.sin(a) * 160,
      r: 4,
      fill: i % 2 === 0 ? '#138808' : '#ffffff',
      stroke: '#06038D',
      'stroke-width': 0.6,
    }));
  }
  svg.append(innerRing);

  svg.append(s('circle', { cx: 300, cy: 300, r: 36, fill: 'rgba(7,17,31,0.85)', stroke: 'rgba(255,255,255,0.2)', 'stroke-width': 1 }));
  svg.append(s('circle', { cx: 300, cy: 300, r: 7, fill: '#06038D' }));
  svg.append(s('circle', { cx: 300, cy: 300, r: 14, fill: 'none', stroke: '#FF9933', 'stroke-width': 1.2 }));

  const head = h('div', { class: 'section-head reveal', style: 'text-align:center; margin-inline:auto;' },
    h('h2', {}, 'Knowledge in orbit.'),
  );

  const stage = h('div', { class: 'orbit-stage reveal' });
  stage.append(svg);

  return h('section', { class: 'orbit', 'aria-label': 'Knowledge in orbit' },
    h('div', { class: 'container' }, head, stage),
  );
}
